const flashMessage = document.getElementById("flash-message");
if (flashMessage) {
  setTimeout(() => {
    flashMessage.style.transition = "opacity 0.5s";
    flashMessage.style.opacity = "0";
    setTimeout(() => {
      flashMessage.classList.add("hidden");
    }, 500);
  }, 3000);
}

// Legacy .alert-box banners rely on Foundation's JS alert plugin for their
// close button, which is never initialized anywhere in this app.
document.addEventListener("click", (event) => {
  const closeButton = event.target.closest(".alert-box .close");
  if (!closeButton) return;

  event.preventDefault();
  closeButton.closest(".alert-box").remove();
});